import { push } from 'react-router-redux';
import { uploadFile } from './screens/EpisodeEditorScreen/duck';
import {
  updateUploadedRecordedAudio,
  fetchMyLibrary,
  receiveLocalRecording,
} from './sourceAudio';
import { formatDate } from './utils';

const PREFIX = '@@recorder/';

export const RECORDER_START = `${PREFIX}START`;
export const RECORDER_STOP = `${PREFIX}STOP`;
export const RECORDER_PAUSE = `${PREFIX}PAUSE`;
export const RECORDER_RESUME = `${PREFIX}RESUME`;
export const RECORDER_ON_STOP = `${PREFIX}ON_STOP`;
export const RECORDER_GOT_SOUND = `${PREFIX}GOT_SOUND`;
export const RECORDER_GOT_STREAM = `${PREFIX}GOT_STREAM`;
export const RECORDER_UNMOUNT = `${PREFIX}UNMOUNT`;
export const RECORDER_VOLUME = `${PREFIX}VOLUME`;
export const RECORDER_UPLOADING = `${PREFIX}UPLOADING`;

const defaultState = {
  active: false, // is recorder currently recording a segment
  audioDetected: false, // have we detected a voice from the stream
  command: 'none', // last command
  stream: null, // the active stream being recorded
  files: [], // files from blobs of recordings after recording stop
  isUploading: false,
  microphone: null, // microphone (from )
};

// reducer
export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case RECORDER_START:
      return Object.assign({}, state, { active: true, command: 'start' });
    case RECORDER_STOP:
      return Object.assign({}, state, { active: false, command: 'stop' });
    case RECORDER_PAUSE:
      return Object.assign({}, state, { active: true, command: 'pause' });
    case RECORDER_RESUME:
      return Object.assign({}, state, { active: true, command: 'resume' });
    case RECORDER_ON_STOP:
      return Object.assign({}, state, {
        files: state.files.concat(action.file),
      });
    case RECORDER_GOT_SOUND:
      return Object.assign({}, state, { audioDetected: true });
    case RECORDER_GOT_STREAM:
      const microphone = action.microphone || state.microphone;
      return Object.assign({}, state, { stream: action.stream, microphone });
    case RECORDER_UNMOUNT:
      return Object.assign({}, state, {
        active: false,
        command: 'none',
        stream: null,
      });
    case RECORDER_UPLOADING:
      return Object.assign({}, state, {
        isUploading: action.payload.isUploading,
      });
    default:
      return state;
  }
}

function blobToFile(blob, duration) {
  // Standardize the blob file to redux reducers here
  // TODO: figure out a better unique filename
  const date = new Date();
  const name = formatDate(date, 'hours', {
    isShortFormat: true,
  });
  blob.caption = name;
  blob.name = name;
  blob.lastModifiedDate = date;
  blob.created = date.toString();
  blob.lastModified = date.getTime();
  const url = window.URL.createObjectURL(blob);
  blob.preview = url;
  blob.url = url;
  blob.audioId = url;
  blob.duration = duration;
  return blob;
}

export const recorderStart = () => ({ type: RECORDER_START });

export const recorderStop = () => ({ type: RECORDER_STOP });

export const recorderPause = () => ({ type: RECORDER_PAUSE });

export const recorderResume = () => ({ type: RECORDER_RESUME });

export const recorderOnStop = file => ({
  type: RECORDER_ON_STOP,
  file,
});

export const recorderGotSound = () => ({ type: RECORDER_GOT_SOUND });

export const recorderGotStream = (stream, microphone) => ({
  type: RECORDER_GOT_STREAM,
  stream,
  microphone,
});

export const recorderUnmount = stream => ({
  type: RECORDER_UNMOUNT,
  stream,
});

export const recorderVolumeChange = value => ({
  type: RECORDER_VOLUME,
});

export const setIsUploading = isUploading => ({
  type: RECORDER_UPLOADING,
  payload: {
    isUploading,
  },
});

export function receiveAndUploadRecording(blob, duration, baseUrl) {
  return dispatch => {
    const file = blobToFile(blob, duration);
    const tempAudioId = file.audioId;
    dispatch(
      receiveLocalRecording({
        ...file,
        key: `${tempAudioId}-0`,
        isUploading: true,
      })
    );
    dispatch(recorderOnStop(file));
    dispatch(push(`${baseUrl}library`));
    return dispatch(
      uploadFile(file, {
        doShowProgress: false,
        isWebRecording: true,
      })
    )
      .then(response => {
        const audioUpdate = {
          ...file,
          ...response.audio,
          isUploading: false,
        };
        dispatch(updateUploadedRecordedAudio(tempAudioId, audioUpdate));
      })
      .then(() => {
        dispatch(fetchMyLibrary({ isCacheBust: true }));
      });
  };
}
